import { Component } from '@angular/core';
import { AbstractFieldComponent } from '../abstract-field.component';

@Component( {
    selector: 'erp-pbw-arbeitslos',
    templateUrl: './checkbox-field.component.html'
} )
export class UnemployedFormComponent extends AbstractFieldComponent<boolean>   {

    constructor() {
        super( 'rm.erp.jobapplication.JobApplication.unemployed' );
    }

    set value( t: boolean | undefined ) {
        if ( this.jobapplication != null ) {
            this.jobapplication.unemployed = t;
        }
    }

    get value(): boolean | undefined {
        return this.jobapplication?.unemployed;
    }
}
